import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import './CompareModal.scss'

@inject('auth') @observer
export default class CompareModal extends Component {

  renderResultGender = (gender) => {
    const {  auth: { pushAuth } } = this.props
    if (!pushAuth.showPgsGender) {
      return <li className='resultDetailText'>XN</li>
    }
    if (gender !== '' && gender !== undefined) {
      return (
        <li className='resultDetailText'>
          {gender}
        </li>
      )
    } else {
      return ''
    }
  }

  renderResultAneu = (aneu) => {
    if (aneu !== '' && aneu !== undefined) {
      const resultAneu = aneu.split(';').join('; ').split(' ')
      return (
        resultAneu.map((item, index) => {
          if (item !== '') {
            return (
              <li key={index} className='resultDetailText'>
                {item}
              </li>
            )
          } else {
            return null
          }
        })
      )
    } else {
      return (
        <li className='resultDetailText'>未见异常</li>
      )
    }
  }

  renderResultCNV = (cnv) => {
    if (cnv !== '' && cnv !== undefined) {
      const resultCNV = cnv.split(';').join('; ').split(' ')
      return (
        resultCNV.map((item, index) => {
          if (item !== '') {
            return (
              <li key={index} className='resultDetailText'>
                {item}
              </li>
            )
          } else {
            return null
          }
        })
      )
    } else {
      return (
        <li className='resultDetailText'>未见异常</li>
      )
    }
  }
  
  renderResultMany = (detailData) => {
    if (
      detailData.ployStatistical !== "" &&
      detailData.ployStatistical !== undefined &&
      detailData.ployStatistical !== null &&
      (detailData.ployStatistical.Ploidy || detailData.ployStatistical.Zscore)
    ) {
      return (
        <li className="resultDetailText">
          {detailData.ployStatistical.Ploidy}
          {detailData.ployStatistical.Zscore!=='NA'?'('+detailData.ployStatistical.Zscore+')':''}
        </li>
      )
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultROH = (detailData) => {
    if (
      detailData.rohStatistical !== "" &&
      detailData.rohStatistical !== undefined &&
      detailData.rohStatistical !== null &&
      detailData.rohStatistical.ROHResult
    ) {
      if (detailData.rohStatistical.ROHResult !== "无法判断") {
        const ROHResult = detailData.rohStatistical.ROHResult.split(";").join("; ").split(" ")
        return ROHResult.map((item, index) => {
          if (item !== "") {
            // if(item.indexOf('UPD')>0){
            //   return (
            //     <li key={index} className="resultDetailText Text-weight">
            //       {item}
            //     </li>
            //   )
            // }else{
              return (
                <li key={index} className="resultDetailText">
                  {item}
                </li>
              )
            // }
           
          } else {
            return null
          }
        })
      } else {
        return <li className="resultDetailText">无法判断</li>
      } 
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultM = (result) => {
    if (result !== '' && result !== undefined) {
      return (
        <li className='resultDetailText'>{result}</li>
      )
    } else {
      return <li className='resultDetailText'>无</li>
    }
  }
  parseEnter(str) {
    if (!str || typeof str !== "string") {
      return null
    }

    const strs = str.split("\n")
    const result = []

    for (var i = 0; i < strs.length - 1; i++) {
      result.push(strs[i])
    }
    return result
  }

  render() {
    let { closeModal, detailData } = this.props
    const result = this.parseEnter(detailData.result)

    return (
      <MaterialModal
        wrapClassName='compare-modal-wrap'
        draggable={true}
        className="compare-modal"
        title="报告结果对比"
        visible={true}
        width={1100}
        mask={false}
        footer={false}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => {
            closeModal('compareModalShowed')
          }}
        />
        <div className="compareWrap">
          <div className="result-left">
            <div className="sub-title">报告结果</div>
            <div className='reportResultWrap'>
              <ul>
                <li>
                  <div className='reportResultTitle'>生信报告结论</div>
                  <ul className='resultDetailList'>
                    {this.renderResultGender(result[0])}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'>生信核型结论</div>
                  <ul className='resultDetailList'>
                  {this.renderResultGender(result[3])}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="result-right">
            <div className="sub-title">审核结果</div>
            <div className='reportResultWrap'>
              <ul>
                <li>
                  <div className='reportResultTitle'>生信报告结论</div>
                  <ul className='resultDetailList'>
                    {this.renderResultGender(detailData.recheckSummary)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'>生信核型结论</div>
                  <ul className='resultDetailList'>
                    {this.renderResultAneu(detailData.summaryAneu)}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/azf/ReportDetail/CompareModal.js